import md5 from 'md5';
import React from 'react';

function UserAvatar({ email = '', size = 40 }) {
  const gravatarUrl = email
    ? `https://www.gravatar.com/avatar/${md5(email.toLowerCase().trim())}?s=${size}&d=mp`
    : `https://www.gravatar.com/avatar/00000000000000000000000000000000?s=${size}&d=mp`;

  return (
    <img src={gravatarUrl} alt="User avatar" className="rounded-full" width={size} height={size} />
  );
}

export default UserAvatar;
